(function () {
  'use strict';

  var rootFlag = '__nestCartSavingsZeroClear20260707';
  if (window[rootFlag] && window[rootFlag].version === 'strict-compare-at-20260707') return;

  var state = window[rootFlag] = {
    version: 'strict-compare-at-20260707',
    productCache: {},
    timer: null,
    running: false,
    rerun: false,
    lastValue: null
  };

  var rootSelector = '.cart-modal, #CartDrawer, .cart-drawer, .drawer--cart, .ajax-cart, .ajaxcart, [data-cart-drawer], [data-cart-container]';

  function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function cents(value) {
    if (value == null || value === '') return 0;
    if (typeof value === 'number') return value;
    var number = Number(String(value).replace(/[^0-9.-]/g, ''));
    return Number.isFinite(number) ? Math.round(number) : 0;
  }

  function isVisible(element) {
    if (!element || !document.documentElement.contains(element)) return false;
    if (element.hasAttribute('hidden') || element.getAttribute('aria-hidden') === 'true') return false;
    var style = window.getComputedStyle(element);
    if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
    var rect = element.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function formatMoney(value) {
    var safe = Math.max(0, Math.round(value || 0));
    var dollars = (safe / 100).toFixed(2);
    var parts = dollars.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return safe > 0 ? '-$' + parts.join('.') : '$0.00';
  }

  function cartItemHandle(item) {
    if (item.handle) return item.handle;
    var url = String(item.url || '');
    var match = url.match(/\/products\/([^?/#]+)/);
    return match && match[1];
  }

  function productForHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (state.productCache[handle]) return state.productCache[handle];

    state.productCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .catch(function () {
        return null;
      });

    return state.productCache[handle];
  }

  function variantForItem(product, item) {
    if (!product || !product.variants) return null;
    var variantId = Number(item.variant_id || item.id);
    for (var i = 0; i < product.variants.length; i += 1) {
      if (Number(product.variants[i].id) === variantId) return product.variants[i];
    }
    return null;
  }

  function lineSavings(item, variant) {
    var quantity = Number(item.quantity || 0);
    if (!quantity) return 0;

    var finalUnit = cents(item.final_price || item.discounted_price || item.price || (variant && variant.price));
    var compareAt = cents(variant && variant.compare_at_price);
    var compareSavings = compareAt > finalUnit ? (compareAt - finalUnit) * quantity : 0;

    var originalLine = cents(item.original_line_price);
    var finalLine = cents(item.final_line_price);
    var discountSavings = originalLine > finalLine ? originalLine - finalLine : 0;

    return Math.max(compareSavings, discountSavings, 0);
  }

  function visibleCartRoots() {
    var roots = Array.prototype.slice.call(document.querySelectorAll(rootSelector)).filter(isVisible);
    return roots.filter(function (root) {
      return !roots.some(function (other) {
        return other !== root && other.contains(root) && isVisible(other);
      });
    });
  }

  function savingsLabels(root) {
    return Array.prototype.slice.call(root.querySelectorAll('*')).filter(function (node) {
      var directText = clean(node.childElementCount ? node.firstChild && node.firstChild.textContent : node.textContent);
      var fullText = clean(node.textContent);
      return isVisible(node) && (/^total savings:?$/i.test(directText) || (/total savings/i.test(fullText) && fullText.length < 80));
    }).filter(function (node) {
      return !Array.prototype.slice.call(node.children || []).some(function (child) {
        return /total savings/i.test(child.textContent || '');
      });
    });
  }

  function savingsBlock(label) {
    var node = label;
    for (var depth = 0; node && depth < 6; depth += 1, node = node.parentElement) {
      var text = clean(node.textContent);
      if (node.classList && node.classList.contains('order-discount-card-wrapper')) return node;
      if (/total savings/i.test(text) && /\$\s*[0-9]/.test(text) && text.length < 160) return node;
    }
    return null;
  }

  function amountElement(block, label) {
    if (!block || !label) return null;
    var candidates = Array.prototype.slice.call(block.querySelectorAll('*')).filter(function (node) {
      var text = clean(node.textContent);
      return node !== label && node.children.length === 0 && /^-?\$\s*[0-9,]+(?:\.\d{2})?$/.test(text) && isVisible(node);
    });
    return candidates.length ? candidates[candidates.length - 1] : null;
  }

  function renderSavings(value) {
    var roots = visibleCartRoots();
    var nextText = formatMoney(value);
    var updated = false;

    roots.forEach(function (root) {
      savingsLabels(root).forEach(function (label) {
        var block = savingsBlock(label);
        var amount = amountElement(block, label);
        if (!block || !amount) return;

        if (clean(amount.textContent) !== nextText) amount.textContent = nextText;
        amount.setAttribute('data-nest-savings-source', 'compare-at-cart-data');
        block.removeAttribute('data-nest-savings-zero-hidden');
        block.removeAttribute('aria-hidden');
        updated = true;
      });
    });

    if (updated) state.lastValue = value;
  }

  function calculateAndRender() {
    if (state.running) {
      state.rerun = true;
      return;
    }
    state.running = true;

    fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var items = cart && cart.items ? cart.items : [];
        return Promise.all(items.map(function (item) {
          return productForHandle(cartItemHandle(item)).then(function (product) {
            return lineSavings(item, variantForItem(product, item));
          });
        }));
      })
      .then(function (lines) {
        var total = lines.reduce(function (sum, value) { return sum + value; }, 0);
        renderSavings(total);
      })
      .catch(function () {
        if (state.lastValue == null) renderSavings(0);
      })
      .finally(function () {
        state.running = false;
        if (state.rerun) {
          state.rerun = false;
          schedule(300);
        }
      });
  }

  function schedule(delay) {
    clearTimeout(state.timer);
    state.timer = setTimeout(calculateAndRender, delay == null ? 180 : delay);
  }

  document.addEventListener('refreshAjaxCart', function () { schedule(300); }, true);
  document.addEventListener('click', function (event) {
    if (event.target && event.target.closest(rootSelector)) {
      schedule(550);
      setTimeout(function () { schedule(0); }, 1400);
    }
  }, true);
  document.addEventListener('change', function (event) {
    if (event.target && event.target.closest(rootSelector)) schedule(400);
  }, true);

  if (window.MutationObserver) {
    new MutationObserver(function () { schedule(350); }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  schedule(350);
}());